import { useEffect } from 'react'

interface Props {
  element: Document | HTMLElement
  handleInteraction: () => void
}

export const useFirstUserInteraction = ({ element, handleInteraction }: Props) => {
  const handleFirstUserInteractionWrapper = () => {
    handleInteraction()
    cleanUpInteractions()
  }

  const cleanUpInteractions = () => {
    element.removeEventListener('touchstart', handleFirstUserInteractionWrapper)
    element.removeEventListener('mousedown', handleFirstUserInteractionWrapper)
    element.removeEventListener('onfocus', handleFirstUserInteractionWrapper)
    element.removeEventListener('scroll', handleFirstUserInteractionWrapper)
    element.removeEventListener('mousemove', handleFirstUserInteractionWrapper)
  }

  const handleFirstInteraction = () => {
    element.addEventListener('touchstart', handleFirstUserInteractionWrapper, { once: true, passive: true })
    element.addEventListener('mousedown', handleFirstUserInteractionWrapper, { once: true, passive: true })
    element.addEventListener('onfocus', handleFirstUserInteractionWrapper, { once: true, passive: true })
    element.addEventListener('scroll', handleFirstUserInteractionWrapper, { once: true, passive: true })
    element.addEventListener('mousemove', handleFirstUserInteractionWrapper, { once: true, passive: true })
  }

  useEffect(() => {
    return () => {
      cleanUpInteractions()
    }
  }, [])

  return {
    handleFirstInteraction,
  }
}
